var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBellIconHalfColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.334 6.668V5.334a5.334 5.334 0 0 0-10.668 0v1.334a2.961 2.961 0 0 1-1.032 2.128 2.789 2.789 0 0 0-.968 1.872c0 1.667 2.741 2.667 7.334 2.667 4.592 0 7.334-1 7.334-2.667a2.789 2.789 0 0 0-.969-1.872 2.96 2.96 0 0 1-1.031-2.128Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.096 14.602a1.995 1.995 0 0 0 3.807 0c-.596.044-1.23.066-1.903.066-.674 0-1.308-.02-1.904-.066Z"
})));
export default SvgBellIconHalfColor;